import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";

const RefundPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Box>
        <Typography variant="h4" fontWeight="bold" gutterBottom color="primary">
          Refund & Credit Policy
        </Typography>
        <Typography variant="caption" color="text.secondary" gutterBottom>
          Last Updated: April 21, 2025
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography paragraph>
          At CakeyHand, we care deeply about your experience and satisfaction.
          If something goes wrong, we want to make it right — within reason and
          fairness. Please review the policy below before requesting a refund or
          store credit.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          1. Refund Eligibility
        </Typography>
        <Typography component="ul" sx={{ pl: 3 }}>
          <li>
            Refunds or credits may be issued in cases of:
            <ul style={{ paddingLeft: 16 }}>
              <li>
                Noticeable damage or major issues with decoration or structure
                at the time of pickup or delivery
              </li>
              <li>
                Service failure (e.g., missed delivery or incorrect order)
              </li>
            </ul>
          </li>
          <li>Requests must be submitted within 24 hours of fulfillment</li>
          <li>Proof (photos or videos) may be required</li>
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          2. Non-Refundable Scenarios
        </Typography>
        <Typography component="ul" sx={{ pl: 3 }}>
          <li>
            Specialty or Custom cake orders cancelled within 7 days of
            pickup/delivery date
          </li>
          <li>
            Other order items cancelled within 48 hours of pickup/delivery date
          </li>
          <li>Change-of-mind after pickup/delivery</li>
          <li>Issues due to improper storage or delayed pickup</li>
          <li>Minor aesthetic differences on custom orders</li>
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          3. Resolution Process
        </Typography>
        <Typography paragraph>
          Each refund or credit request is reviewed manually. Depending on the
          situation, we may:
        </Typography>
        <Typography component="ul" sx={{ pl: 3 }}>
          <li>Issue a full or partial refund</li>
          <li>Provide store credit toward a future order</li>
          <li>Decline the request (with a clear explanation)</li>
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          4. How to Request a Refund or Credit
        </Typography>
        <Typography paragraph>
          Please email <strong>contact@cakeyhand.com</strong> with the
          following:
        </Typography>
        <Typography component="ul" sx={{ pl: 3 }}>
          <li>Your full name and order number</li>
          <li>Reason for the request</li>
          <li>Relevant photos or videos (if applicable)</li>
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="body2" color="text.secondary">
          This policy helps us protect the integrity of our work while ensuring
          every customer is treated with care and fairness.
        </Typography>
      </Box>
    </Container>
  );
};

export default RefundPolicy;
